import { Box, Select, Stack, Text as ChakraText } from '@chakra-ui/react'
import React, { useState } from 'react'
import { colors } from '../../../ui-kit'
import PageNavigator from './PageNavigator'

const Pagination = ({
  pageIndex,
  pageSize,
  canPreviousPage,
  canNextPage,
  pageCount,
  pageOptions,
  setPageSize,
  previousPage,
  nextPage,
  gotoPage,
}: {
  pageIndex: number
  pageSize: number
  canPreviousPage: boolean
  canNextPage: boolean
  pageCount: number
  pageOptions: number[]
  setPageSize(pageSize: number): void
  previousPage(): void
  nextPage(): void
  gotoPage(updater: number): void
}): React.ReactElement => {
  const [currentPage, setCurrentPage] = useState(pageIndex + 1)
  if (pageOptions.length === 0) {
    return <></>
  }

  return (
    <Stack align="center" direction={['row']} spacing="3em">
      <Stack align="center" direction={['row']} spacing="1em">
        <ChakraText>Show</ChakraText>
        <Select
          w={20}
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 25, 50, 100].map(count => (
            <option key={count} value={count}>
              {count}
            </option>
          ))}
        </Select>
        <ChakraText>Entries</ChakraText>
      </Stack>

      <PageNavigator
        pageIndex={pageIndex}
        pageCount={pageCount}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        previousPage={previousPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
      />

      <Stack align="center" direction={['row']} spacing="1em">
        <ChakraText minWidth={16}>Go To</ChakraText>
        <Select
          w={20}
          value={currentPage}
          onChange={e => {
            setCurrentPage(Number(e.target.value))
          }}
        >
          {Array.from(Array(pageOptions.length).keys()).map(count => (
            <option key={count + 1} value={count + 1}>
              {count + 1}
            </option>
          ))}
        </Select>
        <Box
          borderRadius="5px"
          cursor="pointer"
          padding="7px 8px"
          border="solid 1px"
          borderColor={colors.appClearBlue}
          backgroundColor={colors.appPaleGreyTwo}
          onClick={() => {
            gotoPage(currentPage - 1)
          }}
        >
          GO
        </Box>
      </Stack>
    </Stack>
  )
}

export default Pagination
